import { useLayoutEffect } from 'react';
import routes from 'Routes/routes';
import PrivateRoute from 'Routes/PrivateRoute';
import { Route, useHistory, Switch } from 'react-router-dom';
import Footer from 'Components/Common/Footer';
import Header from 'Components/Common/Header';
import Sidemenu from 'Components/Common/SideMenu';
import { AutoLogout } from '../Helpers/AutoLogout';
import routesPath from 'Constants/routes.constants';

window.addEventListener('click', AutoLogout)
window.addEventListener('keypress', AutoLogout)

const RedirectToPageNotFound = () => {
	const history = useHistory();
	useLayoutEffect(() => {
		history.push(routesPath.pageNotFound);
	}, [ history ]);
	return null;
};

function SwitchRoutes() {
  AutoLogout()
  return (
    <>
      <Sidemenu />
      <div className='pageContainer' id='maincontainer'>
        <Header />
        <Switch>
          {routes.map((prop, key) =>
            prop.route === 'private' ? (
              <PrivateRoute
                path={ prop.path }
                component={ prop.component }
                key={ key }
                exact={ prop.exact }
                name={ prop.name }
              />
            ) : (
              <Route
                path={ prop.path }
                component={ prop.component }
                key={ key }
                exact={ prop.exact }
              />
            )
          )}
          <Route component={ RedirectToPageNotFound } />
        </Switch>
      </div>
      <Footer />
    </>
  );
}

export default SwitchRoutes;
